import React, { createContext, useState, useEffect } from 'react';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from '../config/firebase';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {

        try {
            const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
                setUser(currentUser);
                setLoading(false);
            });

            return () => unsubscribe();
        } catch (err) {
            console.error('Erreur AuthProvider:', err);
            setError(err.message);
            setLoading(false);
        }
    }, []);

    // Fonction de déconnexion
    const logout = async () => {
        try {

            await signOut(auth);

            setUser(null);
            return true;
        } catch (err) {
            console.error('AuthContext.logout: Erreur:', err);
            throw err;
        }
    };

    return (
        <AuthContext.Provider value={{ user, loading, error, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
